export interface OrderedLog {
  id?: number;
  timeUtc: number;
}

export function compareLogs(a: OrderedLog, b: OrderedLog): number {
  const byTime = a.timeUtc - b.timeUtc;
  if (byTime != 0) return byTime;
  const aCommitted = (a.id ?? 0) > 0;
  const bCommitted = (b.id ?? 0) > 0;
  if (aCommitted != bCommitted) return aCommitted ? -1 : 1;
  return aCommitted ? (a.id ?? 0) - (b.id ?? 0) : 0;
}
